import { useState, useEffect } from "react";

export default function useDarkSide() {
  const getInitialTheme = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      // First visit: if no theme is set, initialize with 'dark'
      const storedTheme = localStorage.getItem("theme");
      if (storedTheme !== "dark") {
        localStorage.setItem("theme", "dark");
        return "dark";
      }
      return storedTheme;
    }
    return "dark";
  };

  const [theme, setTheme] = useState(getInitialTheme);
  const colorTheme = theme === "dark" ? "light" : "dark";

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(colorTheme);
    root.classList.add(theme);
    localStorage.setItem("theme", theme);
  }, [theme, colorTheme]);

  return [colorTheme, setTheme];
}
